import React, { useMemo } from 'react';
import { CandlestickChart } from 'lucide-react';
import { usd } from './components';
import { useT } from '../../i18n';

/**
 * BTC/USDT candles, so a player can see where the price has been before naming
 * a number. TradingView's embed is an iframe, so it carries no script into the
 * app, and the round is still settled by the Chainlink feed the contract reads,
 * not by anything shown here.
 *
 * The widget keeps its own toolbar (intervals, indicators, drawing), so there is
 * no second set of controls here to fight with it. It opens on 4H, matching the
 * round length.
 */
const BtcChart = ({ price, roundedPrice }) => {
  const t = useT();
  const src = useMemo(() => {
    const params = new URLSearchParams({
      symbol: 'BINANCE:BTCUSDT',
      interval: '240',
      theme: 'dark',
      style: '1',
      timezone: 'Etc/UTC',
      locale: 'en',
      withdateranges: '1',
      hidesidetoolbar: '1',
      saveimagebtn: '0',
      backgroundColor: 'rgba(12,8,17,1)',
      gridColor: 'rgba(255,255,255,0.06)',
    });
    return `https://s.tradingview.com/widgetembed/?${params.toString()}`;
  }, []);

  return (
    <section className="lb-card overflow-hidden">
      <header className="flex flex-wrap items-baseline justify-between gap-3 border-b border-white/5 px-5 py-4">
        <h3 className="lb-heading flex items-center gap-2 text-xl">
          <CandlestickChart className="h-5 w-5 text-brand-cyan" aria-hidden="true" />
          BTC / USDT
        </h3>
        {price ? (
          <p className="notranslate lb-num text-sm text-white/50">
            ${usd(price, 2)}
            {roundedPrice ? (
              <span className="text-white/35"> · target ${usd(roundedPrice)}</span>
            ) : null}
          </p>
        ) : null}
      </header>

      <div className="h-[340px] sm:h-[440px]">
        <iframe
          title={t('bullseye.chartAlt')}
          src={src}
          className="h-full w-full border-0"
          loading="lazy"
          allow="fullscreen"
        />
      </div>
    </section>
  );
};

export default BtcChart;
